import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const EventIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const svgColor = Colors24[color]
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.11111 3.63889V0.75M10.8889 3.63889V0.75M2.94444 13.75H13.0556C13.8533 13.75 14.5 13.1033 14.5 12.3056V3.63889C14.5 2.84114 13.8533 2.19444 13.0556 2.19444H2.94444C2.1467 2.19444 1.5 2.84114 1.5 3.63889V12.3056C1.5 13.1033 2.1467 13.75 2.94444 13.75Z"
        stroke={svgColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.40039 8.30874L7.00039 9.84948L10.6004 6.38281"
        stroke={svgColor}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  )
}
